module.exports = __webpack_public_path__ + "assets/img/1.3efd30d1.png";